import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserModel } from 'src/app/models/auth/user-model';
import { AuthserviceService } from 'src/app/services/authservice.service';
import { AppSessionStorageService } from 'src/app/services/utils/session-storage.service';

@Component({
  selector: 'app-customer-card',
  standalone: true,
  imports: [],
  templateUrl: './customer-card.component.html',
  styleUrl: './customer-card.component.css'
})
export class CustomerCardComponent {
  @Input() showCustomerDetailsPopUp!:boolean
  @Input() customerDetails!:UserModel
  @Output() closeModal = new EventEmitter()
  userDetails!:UserModel | undefined
  constructor(
    private auth: AuthserviceService,
    
  ) {}

  get userDetailsInfo(){
    if(AppSessionStorageService.user){
    return AppSessionStorageService.user
    
    }
    return undefined

  }
  get profileImage(): string {
    return this.auth.getUserImage() ?? 'assets/default-image.svg';
  }

  modalClose(){
    this.closeModal.emit(true)
  }
}
